<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a Work Order Charge"
    @on-hide="() => workOrder = null"
  >
    <b-form
      novalidate
      @submit.stop.prevent="handleSubmit"
    >
      <b-row>
        <b-col>
          <b-form-group
            label="Search for a Work Order to Pay"
            label-for="technician-payment-item-add-work-order-charge-work_order_charge_id"
          >
            <work-order-charges-select
              id="technician-payment-item-add-work-order-charge-work_order_charge_id"
              :value="workOrder"
              :select-class="{ 'is-invalid': $v.form.work_order_charge_id.$dirty && $v.form.work_order_charge_id.$error }"
              :filter-params="workOrderSelectParams"
              @input="onWorkOrderChange"
            />
            <b-form-invalid-feedback
              v-if="$v.form.work_order_charge_id.$dirty"
              id="technician-payment-item-add-work-order-charge-work_order_charge_id-feedback"
            >
              <span v-if="!$v.form.work_order_charge_id.required">Please enter a work order charge.</span>
              <span v-if="!$v.form.work_order_charge_id.serverFailed">{{ serverErrors.reference_id }}</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <hr class="mt-4">

      <b-row>
        <b-col
          offset-lg="6"
          lg="3"
          order="2"
          order-lg="1"
        >
          <b-button
            variant="link-dark"
            block
            id="technician-payment-item-add-work-order-charge-close-button"
            @click="closeModal"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col
          lg="3"
          order="1"
          order-lg="2"
        >
          <b-button
            id="technician-payment-item-add-work-order-charge-submit-button"
            block
            type="submit"
            variant="primary"
            :disabled="processing"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </sfs-form-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import formMixin from '@/mixins/formMixin';
import formModalMixin from '@/mixins/formModalMixin';
import WorkOrderChargesSelect from '@/components/admin/workOrderCharges/Select';
import {
  WORK_ORDER_STATUS_ASSIGNED,
  WORK_ORDER_STATUS_IN_PROGRESS,
  WORK_ORDER_STATUS_COMPLETED,
  WORK_ORDER_STATUS_INVOICED,
} from '@/constants/workOrders';

export default {
  name: 'TechnicianPaymentsAddWorkOrderChargesModal',
  mixins: [formMixin, formModalMixin],
  components: {
    WorkOrderChargesSelect,
  },
  props: {
    technician_payment_id: Number,
    user_id: Number,
    work_order_charge_id: Number,
  },
  data() {
    return {
      form: {
        work_order_charge_id: this.work_order_charge_id,
      },
      fieldLabels: {
        work_order_charge_id: 'Work Order Charge',
      },
      workOrder: null,
      workOrderSelectParams: {
        technician_paid: false,
        user_id: this.user_id,
        statuses: [
          WORK_ORDER_STATUS_ASSIGNED,
          WORK_ORDER_STATUS_IN_PROGRESS,
          WORK_ORDER_STATUS_COMPLETED,
          WORK_ORDER_STATUS_INVOICED,
        ],
      },
      modalId: 'technician-payment-item-add-work-order-charge-modal',
    };
  },
  validations: {
    form: {
      work_order_charge_id: {
        required,
        serverFailed() {
          return !this.hasServerErrors('reference_id');
        },
      },
    },
  },
  methods: {
    onWorkOrderChange(workOrder) {
      this.form.work_order_charge_id = workOrder ? workOrder.id : '';
      this.workOrder = workOrder;
    },
    handleSubmit() {
      if (this.hasFormErrors()) {
        return;
      }
      this.processing = true;
      this.$technicianPaymentsAPI
        .createWorkOrderChargeItem(this.technician_payment_id, this.form)
        .then(() => {
          this.resetServerErrors();
          this.$v.$reset();
          this.$emit('on-save');
          this.closeModal();
          this.processing = false;
        })
        .catch((error) => {
          this.processServerErrors(error.response.data.errors);
          this.processing = false;
        });
    },
  },
};
</script>
